Monitoring.Views ||= {}
class AccountSettings.FilterAndOrderSelectionView extends Backbone.View
  MAX_LENGTH = 85
  template: JST["backbone/templates/account_settings/acd_setting/filter_and_order_selection"]
  events:
    'click .remove-selection': 'onRemoveSelection'
  tagName: 'div'
  className: 'selected_filter'

  initialize: (@options = {}) ->
    @filter = @options.filter
    @order = @options.order

  render: =>
    @$el.html(@template({filter_name: @filter.filter_name, filter_id: @filter.filter_id, order_name: @order.order_text, full_order_text: @order.full_order_text, order_code: @order.order_code}))
    @_trimText()
    @

  _trimText: ->
    lengthSum = 0
    _.each(@$el.find('#filter-description>span'), (span) =>
      lengthSum += span.innerText.length
    )
    orderName = @order.order_text
    lengthSum += orderName.length
    if lengthSum > MAX_LENGTH
      trimmedText = orderName.substr(0, orderName.length - (lengthSum - MAX_LENGTH)) + '...'
      @$el.find('.tray_order').text(trimmedText)
    else
      @$el.find('.tray_order').removeAttr('title')

  onRemoveSelection:->
    @trigger('selection:remove', @)

  toJson:=>
    {filter_id: @filter.filter_id, display_name: @filter.filter_name ,order: @order.order_code}
